const getters = {
  color: state => {
    return state.theme.color
  },
  logo: state => {
    return state.theme.logo
  },
  favicon: state => {
    return state.theme.favicon
  },
  preview: state => {
    return state.theme.preview
  },
  brandTitle: state => {
    return state.theme.brandTitle
  },
  currentTheme: state => {
    return state.theme
  },
  themeList: state => {
    return state.themeList
  },
}

export default getters
